<template>
    <div class="mail-wrapper">
        <div class="mail-group">
            <div class="mail-group-header">
                <i data-feather="search"></i>
                <div class="search-form">
                    <input v-model="search" type="search" class="form-control" placeholder="Search messages">
                </div>
            </div>
            <div class="mail-group-body">
                <div class="pd-y-15 pd-x-20 d-flex justify-content-between align-items-center bd-b">
                    <h6 class="tx-uppercase tx-semibold mg-b-0">Messages <span class="d-none">({{ unreadMessagesCount }})</span></h6>
                    <div class="dropdown tx-13">
                        <span class="tx-color-03">Sort:</span> 
                        <a href="#sort" class="dropdown-link link-02" @click.prevent>Date</a>
                    </div>
                </div>
                <div v-if="loading" class="pd-y-15">
                    <spinner-component :classes="'spinner-border'" :loading="loading"/>
                </div>

                <div v-if="data" class="mail-group-body-inbox ps ps--active-y">
                    <inbox-list :messages="filteredMessages"/>
                    <div class="pd-t-1 pd-b-5 pd-x-5" :class="{ 'd-none': isFinished }">
                        <a href="#load-more" class="btn btn-xs btn-block btn-light bd-0 tx-uppercase tx-10 tx-spacing-1 tx-medium mn-ht-0 shadow-sm" @click.prevent="loadMore">
							<span v-if="isLoadingMore" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							<span>{{ (isLoadingMore) ? 'Loading...' : 'Load more' }}</span>
						</a>
                    </div>
                </div>
                <div v-else>

                </div>
            </div>
        </div>
        <div class="mail-content">
            <div v-if="error" class="tx-center tx-danger">
                {{ error }}
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<style scoped>
	.mail-group-body-inbox {
		position: absolute;
		top: 50px;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.spinner-border-sm {
		width: 0.75rem;
		height: 0.75rem;
		border-width: 0.2em;
	}
</style>

<script>
	import PerfectScrollbar from "perfect-scrollbar";
	import "../../../../../js/scripts/mail";

	export default {
		mounted() {
			if (this.$route.name === "messages.inbox") {
				this.loading = true;
			}
		},
		data() {
			return {
				search: null,
				loading: false,
				isLoadingMore: false,
				load: null,
				last_page: null,
				isFinished: false,
				data: null,
				messages: [],
				error: null
			};
		},
		created() {
			this.load = 1;

			this.fetchMessages();
		},
		updated() {
			$(".tooltip").tooltip("hide");

			if (this.$route.name === "messages.inbox") {
				$("body").removeClass("mail-content-show");
			}
		},
		computed: {
			filteredMessages() {
				const messages = this.messages;

				if (this.search) {
					return messages.filter(message => {
						const results =
							message.customer_details.name
								.toLowerCase()
								.includes(this.search.toLowerCase()) ||
							message.topic
								.toLowerCase()
								.includes(this.search.toLowerCase()) ||
							message.subject
								.toLowerCase()
								.includes(this.search.toLowerCase());

						return results;
					});
				}

				return messages;
			},
			unreadMessagesCount() {
				let count = 0;

				if (this.messages) {
					count = this.messages.unread;
				}

				return count;
			}
		},
		watch: {
			data: function({ current_page, last_page }) {
				this.isFinished = current_page === last_page;
			}
		},
		methods: {
			loadMore() {
				this.isLoadingMore = true;
				this.load++;

				this.fetchMessages();
			},
			fetchMessages() {
				this.error = null;

				axios
					.get("/api/messages", {
						params: {
							paginate: 100,
							load: this.load
						}
					})
					.then(response => {
						const messages = response.data.data.messages;

						if (!_.isEmpty(messages.data)) {
							this.data = messages;
							this.messages.push(...messages.data);
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						new PerfectScrollbar(".mail-group-body-inbox", {
							suppressScrollX: true
						});

						this.loading = this.isLoadingMore = false;
					});
			}
		}
	};
</script>